import { useEffect, useState } from 'react';

import apiToken, { handleApiError } from '@/shared/services/axiosInstance';
import { useAuthStore } from '@/shared/stores/useAuthStore';
import { ProductCardData } from '@/shared/types/ProductCardTypes';

import ContactUsBanner from './components/UI/ContactUsBanner';
import ProductSection from './components/UI/ProductSection';

const Main = () => {
  const [productList, setProductList] = useState<ProductCardData[]>([]);
  const [merchList, setMerchList] = useState<ProductCardData[]>([]);
  const [megazineList, setMegazineList] = useState<ProductCardData[]>([]);
  const [stripeBannerList, setStripeBannerList] = useState<Array<any>>([]);
  const [squareBannerList, setSquareBannerList] = useState<Array<any>>([]);

  const getProductList = async () => {
    try {
      const [productRes, merchRes, megazineRes] = await Promise.all([
        apiToken.get(
          '/api/v1/product/list?page=1&limit=24&sort=latest&stockStatus=all',
        ),
        apiToken.get(
          '/api/v1/product/list?page=1&limit=8&sort=latest&stockStatus=all&categoryId=9',
        ),
        apiToken.get(
          '/api/v1/product/list?page=1&limit=8&sort=latest&stockStatus=all&categoryId=2',
        ),
      ]);

      setProductList(productRes.data.data.productOptionList);
      setMerchList(merchRes.data.data.productOptionList);
      setMegazineList(megazineRes.data.data.productOptionList);
    } catch (error: any) {
      const errorMessage = handleApiError(error);
      console.error('Error fetching product list:', errorMessage);

      if (errorMessage === 'Your account is pending approval.') {
        alert('Your account is pending approval. Please contact support.');
        useAuthStore.getState().clearToken();
      } else {
        alert(
          errorMessage || 'Failed to load products. Please try again later.',
        );
      }
    }
  };

  useEffect(() => {
    getProductList();
  }, []);

  return (
    <main>
      <ProductSection
        productList={productList}
        title="PRE-ORDER"
        categoryId={0}
      />
      <ProductSection productList={merchList} title="K-MERCH" categoryId={9} />
      <ProductSection
        productList={megazineList}
        title="K-MAGAZINE"
        categoryId={2}
      />
      <ContactUsBanner />
    </main>
  );
};

export default Main;
